import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { aiServiceCapabilities } from '@/mocks/jiuchou-ai';

export default function AIServiceProvider() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="AI 应用服务商"
            title="华辉数智 · AI 应用服务四大能力"
            subtitle="华辉数智作为人工智能应用服务商（交付实施类），以「TOMA 智能体 + 数字货架 + 车载卡 + 系统开发」为核心优势。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {aiServiceCapabilities.map((c, i) => (
            <Reveal key={c.no} delay={i * 70}>
              <div
                className={`h-full p-6 rounded-lg border flex flex-col ${
                  c.no === '02'
                    ? 'border-primary-300 bg-primary-50'
                    : 'border-background-200 bg-background-100'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${c.icon} text-primary-600 text-2xl`}></i>
                  </div>
                  <span className="font-heading font-bold text-2xl text-foreground-200">{c.no}</span>
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{c.name}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{c.desc}</p>
                {c.items && (
                  <div className="mt-4 flex flex-wrap gap-2">
                    {c.items.map((it) => (
                      <span
                        key={it}
                        className="px-2.5 py-1 text-[11px] rounded-full bg-accent-100 text-accent-900 whitespace-nowrap"
                      >
                        {it}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}